<template>
  <footer id="footer" class="footer">
    <div class="footer-content">
      <img
        src="@/assets/branding/logo-white.svg"
        alt=""
        class="footer-logo"
        aria-hidden="true"
      >
      <div class="social-media">
        <a href="https://facebook.com/singingmolenbeek" target="_blank" rel="noopener noreferrer">
          <img src="@/assets/icons/facebook.svg" alt="Facebook">
        </a>
        <a href="https://instagram.com/singingmolenbeek" target="_blank" rel="noopener noreferrer">
          <img src="@/assets/icons/instagram.svg" alt="Instagram">
        </a>
        <a href="https://vimeo.com/user62138394" target="_blank" rel="noopener noreferrer">
          <img src="@/assets/icons/vimeo.svg" alt="Vimeo">
        </a>
        <a href="mailto:contact@singingmolenbeek.be">
          <img src="@/assets/icons/email.svg" alt="Email">
        </a>
      </div>
      <div class="footer-info">
        <p>{{ $t('footer.copyright') }}</p>
        <p>{{ $t('footer.contact') }}<a href="mailto:contact@singingmolenbeek.be">contact@singingmolenbeek.be</a></p>
      </div>
    </div>
  </footer>
</template>

<script setup>
</script>

<style scoped>
.footer {
  user-select: none;
  -moz-user-select: none;
  -webkit-user-drag: none;
  -webkit-user-select: none;
  -ms-user-select: none;
  margin-top: 0;
  padding: 42px 20px 36px;
  background-color: var(--secondary-color);
  color: white;
  text-align: center;
}

.footer-content {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.footer-logo {
  width: min(230px, 62vw);
  height: auto;
  margin-bottom: 24px;
}

.social-media {
  display: flex;
  justify-content: center;
  gap: 12px;
  margin-bottom: 24px;
}

.social-media a {
  display: inline-flex;
  width: 44px;
  height: 44px;
  align-items: center;
  justify-content: center;
  border: 1px solid rgba(255, 255, 255, 0.18);
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.07);
  transition: border-color 0.2s ease, background-color 0.2s ease, transform 0.2s ease;
}

.social-media img {
  width: 22px;
  height: auto;
  user-select: none;
  -moz-user-select: none;
  -webkit-user-drag: none;
  -webkit-user-select: none;
  -ms-user-select: none;
}

.social-media a:hover {
  border-color: rgba(255, 255, 255, 0.42);
  background: var(--primary-color);
  transform: translateY(-2px);
}

.footer-info {
  text-align: center;
  font-size: 0.94rem;
}

.footer-info p {
  margin: 5px 0;
}

.footer-info a {
  color: #f3cf69;
  text-decoration: none;
}

.footer-info a:hover {
  text-decoration: underline;
}
</style>
